import { useLocation } from "react-router-dom"

import { shouldShowBuildingSwitcher } from "@/config/building-switcher-paths"

/**
 * Custom hook to determine if BuildingSwitcher should be visible
 * based on current route path and configuration
 *
 * @returns boolean - true if BuildingSwitcher should be shown, false otherwise
 */
export const useBuildingSwitcherVisibility = (): boolean => {
  const location = useLocation()

  return shouldShowBuildingSwitcher(location.pathname)
}

/**
 * Custom hook with debug information for development
 * Returns both visibility state and debug info
 */
export const useBuildingSwitcherVisibilityDebug = () => {
  const location = useLocation()
  const isVisible = shouldShowBuildingSwitcher(location.pathname)

  return {
    isVisible,
    currentPath: location.pathname,
    debugInfo: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      state: location.state,
    },
  }
}
